module.exports = __webpack_public_path__ + "static/media/nav-icon-team.ff17c406.svg";